export default __webpack_public_path__ + "static/media/Page5.94b0909f.txt";